<template>
	<div style="background:white;">
    <van-nav-bar title="招聘信息" left-arrow @click-left="$router.back()" left-text="返回" />
		<a href="/home"><img src="@/assets/page/abc.gif" alt="" /></a>
		<div><h1 style="text-align: left;margin-left: 22px;color: #EE7800;">招聘信息</h1></div>
		<div style="background: #F0F0F0;margin:0px 20px; font-size:10px;word-wrap:break-word">
			<div style=" ">
				<van-row><van-col span="8" style="font-weight: 900;color: #026602; font-size: 20px;margin:10px 0px;">记账会计</van-col></van-row>
				<van-row><van-col span="8" style="font-size: 20px;color: #10A01E;">岗位说明</van-col></van-row>
				<van-row><van-col span="24" style="font-size: 20px; text-align: left;margin:10px 10px;">1、根据客户要求独立建立核算账套、处理账务;</van-col></van-row>
				<van-row><van-col span="24" style="font-size: 20px; text-align: left;margin:10px 10px;">2、按公司和财务相关部门的要求准确填写各类报表;</van-col></van-row>
				<van-row><van-col span="24" style="font-size: 20px; text-align: left;margin:10px 10px;">3、记账票据的整理及管理工作;</van-col></van-row>
				<van-row><van-col span="8" style="font-size: 20px;color: #10A01E;">任职资格</van-col></van-row>
				<van-row><van-col span="24" style="font-size: 20px; text-align: left;margin:10px 10px;">1、25-50岁， 中专以上学历;</van-col></van-row>
				<van-row><van-col span="24" style="font-size: 20px; text-align: left;margin:10px 10px;">2、良好的表达及沟通能力;</van-col></van-row>
				<van-row><van-col span="24" style="font-size: 20px; text-align: left;margin:10px 10px;">3、熟悉新中大或其它财务软件;</van-col></van-row>
				<van-row><van-col span="24" style="font-size: 20px; text-align: left;margin:10px 10px;">4、1年以上一般纳税人、2年以上账务处理经验;</van-col></van-row>
				<van-row><van-col span="24" style="font-size: 20px; text-align: left;margin:10px 10px;">5、有会计公司工作经验优先考虑。</van-col></van-row>
				<van-row><van-col span="8" style="font-size: 20px;color: #10A01E;text-align: left;margin-left: 15px;">备注</van-col></van-row>
				<van-row>
					<van-col span="24" style="font-size: 20px; text-align: left;margin:10px 10px;">中关村、洋桥、大兴、十里堡、顺义、石景山、门头沟、安贞地区急招。</van-col>
				</van-row>
				<van-row><van-col span="8" style="font-weight: 900;color: #026602; font-size: 20px;margin:10px 0px;">外勤会计</van-col></van-row>
				<van-row><van-col span="8" style="font-size: 20px;color: #10A01E;text-align: left;margin-left: 15px;">岗位说明</van-col></van-row>
				<van-row><van-col span="24" style="font-size: 20px; text-align: left;margin:10px 10px;">1、定期联系客户，取送资料;</van-col></van-row>
				<van-row><van-col span="24" style="font-size: 20px; text-align: left;margin:10px 10px;">2、协助客户办理工商、税务等工作;</van-col></van-row>
				<van-row><van-col span="24" style="font-size: 20px; text-align: left;margin:10px 10px;">3、协助记账会计年底进行汇算清缴工作;</van-col></van-row>
				<van-row><van-col span="24" style="font-size: 20px; text-align: left;margin:10px 10px;">4、领导交办的其它工作。</van-col></van-row>
				<van-row><van-col span="8" style="font-size: 20px;color: #10A01E;text-align: left;margin-left: 15px;">任职资格</van-col></van-row>
				<van-row><van-col span="24" style="font-size: 20px; text-align: left;margin:10px 10px;">1、20-45岁，中专以上学历;</van-col></van-row>
				<van-row><van-col span="24" style="font-size: 20px; text-align: left;margin:10px 10px;">2、良好的语言表达能力及沟通能力;</van-col></van-row>
				<van-row><van-col span="24" style="font-size: 20px; text-align: left;margin:10px 10px;">3、有会计证，会计公司工作经验者优先考虑。</van-col></van-row>
				<van-row><van-col span="8" style="font-weight: 900;color: #026602; font-size: 20px;margin:10px 0px;">电话销售</van-col></van-row>
				<van-row><van-col span="8" style="font-size: 20px;color: #10A01E;text-align: left;margin-left: 15px;">岗位说明</van-col></van-row>
				<van-row><van-col span="24" style="font-size: 20px; text-align: left;margin:10px 10px;">1、接待官网主动来咨询的同学，邀请体验课程 ;</van-col></van-row>
				<van-row><van-col span="24" style="font-size: 20px; text-align: left;margin:10px 10px;">2、通过网络招生平台和电话，为客户提供专业的课程咨询</van-col></van-row>
				<van-row><van-col span="24" style="font-size: 20px; text-align: left;margin:10px 10px;">3、为客户提供报名咨询服务，促成成交;</van-col></van-row>
				<van-row><van-col span="24" style="font-size: 20px; text-align: left;margin:10px 10px;">4、 有过相关销售经验者优先。</van-col></van-row>

				<van-row><van-col span="8" style="font-size: 20px;color: #10A01E;text-align: left;margin-left: 15px;">任职资格</van-col></van-row>
				<van-row>
					<van-col span="24" style="font-size: 20px; text-align: left;margin:10px 10px;">1、 语言表达能力良好，普通话标准， 有良好的服务意识及销售工作技巧;</van-col>
				</van-row>
				<van-row><van-col span="24" style="font-size: 20px; text-align: left;margin:10px 10px;">2、责任心强,工作积极主动, ;做事专注负责，肯坚持肯担当;</van-col></van-row>
				<van-row>
					<van-col span="24" style="font-size: 20px; text-align: left;margin:10px 10px;">3、态度积极，热心,且善于与人沟通,具有较强的应变和学习能力;</van-col>
				</van-row>
				<van-row><van-col span="24" style="font-size: 20px; text-align: left;margin:10px 10px;">4、有过相关销售经验者优先。</van-col></van-row>

				<van-row><van-col span="8" style="font-weight: 900;color: #026602; font-size: 20px;margin:10px 0px;">客服主管</van-col></van-row>
				<van-row><van-col span="8" style="font-size: 20px;color: #10A01E;text-align: left;margin-left: 15px;">岗位说明</van-col></van-row>
				<van-row><van-col span="24" style="font-size: 20px; text-align: left;margin:10px 10px;">1、负责客服部的业务培训及专业指导。</van-col></van-row>
				<van-row>
					<van-col span="24" style="font-size: 20px; text-align: left;margin:10px 10px;">2、完善客服部统一话术，提高客户服务质量，提升客户满意度。</van-col>
				</van-row>
				<van-row><van-col span="24" style="font-size: 20px; text-align: left;margin:10px 10px;">3、合理安排客服部的工作，完善客服部的团队建设。</van-col></van-row>
				<van-row><van-col span="24" style="font-size: 20px; text-align: left;margin:10px 10px;">4、处理客户投诉，为用户提供合理解决方案。</van-col></van-row>
				<van-row><van-col span="24" style="font-size: 20px; text-align: left;margin:10px 10px;">5、负责客服部的数据分析及相关报表的完成。</van-col></van-row>
				<van-row><van-col span="24" style="font-size: 20px; text-align: left;margin:10px 10px;">6、整理客户反馈的信息，及时与公司相关部门进行沟通。</van-col></van-row>

				<van-row><van-col span="8" style="font-size: 20px;color: #10A01E;text-align: left;margin-left: 15px;">任职资格</van-col></van-row>
				<van-row>
					<van-col span="24" style="font-size: 20px; text-align: left;margin:10px 10px;">1、大专及以上学历，30-45岁，会计、金融或营销相关专业毕业。</van-col>
				</van-row>
				<van-row><van-col span="24" style="font-size: 20px; text-align: left;margin:10px 10px;">2、2年以上客服主管工作经验。</van-col></van-row>
				<van-row><van-col span="24" style="font-size: 20px; text-align: left;margin:10px 10px;">3、良好的协调和沟通能力、人际交往能力和语言表达能力</van-col></van-row>
				<van-row><van-col span="24" style="font-size: 20px; text-align: left;margin:10px 10px;">4、较强的责任心和执行力，富有工作热情和团队意识。</van-col></van-row>
				<van-row><van-col span="24" style="font-size: 20px; text-align: left;margin:10px 10px;">5、 有会计公司工作经验者优先考虑。</van-col></van-row>

				<van-row><van-col span="8" style="font-weight: 900;color: #026602; font-size: 20px;margin:10px 0px;">招生老师</van-col></van-row>
				<van-row><van-col span="8" style="font-size: 20px;color: #10A01E;text-align: left;margin-left: 15px;">岗位说明</van-col></van-row>
				<van-row><van-col span="24" style="font-size: 20px; text-align: left;margin:10px 10px;">1.负责学校培训课程的咨询和招生工作;</van-col></van-row>
				<van-row>
					<van-col span="24" style="font-size: 20px; text-align: left;margin:10px 10px;">2.负责收集、整理、记录报名学员的信息，回访跟进，促进达成;</van-col>
				</van-row>
				<van-row><van-col span="24" style="font-size: 20px; text-align: left;margin:10px 10px;">3.帮助学员办理报名相关手续，及后续的课程指导工作;</van-col></van-row>
				<van-row><van-col span="24" style="font-size: 20px; text-align: left;margin:10px 10px;">4.完成临时性的工作安排;</van-col></van-row>

				<van-row><van-col span="8" style="font-size: 20px;color: #10A01E;text-align: left;margin-left: 15px;">任职资格</van-col></van-row>
				<van-row><van-col span="24" style="font-size: 20px; text-align: left;margin:10px 10px;">1.22-50岁，中专以上学历;</van-col></van-row>
				<van-row><van-col span="24" style="font-size: 20px; text-align: left;margin:10px 10px;">2.良好的语言表达能力及沟通能力;</van-col></van-row>
				<van-row><van-col span="24" style="font-size: 20px; text-align: left;margin:10px 10px;">3.熟练操作office办公软件;</van-col></van-row>
				<van-row><van-col span="24" style="font-size: 20px; text-align: left;margin:10px 10px;">4.从事过教育培训行业、招生工作及销售管理经验者优先;</van-col></van-row>

				<van-row><van-col span="8" style="font-weight: 900;color: #026602; font-size: 20px;margin:10px 0px;">会计讲师</van-col></van-row>
				<van-row><van-col span="8" style="font-size: 20px;color: #10A01E;text-align: left;margin-left: 15px;">岗位说明</van-col></van-row>
				<van-row><van-col span="24" style="font-size: 20px; text-align: left;margin:10px 10px;">1、根据课程安排讲授会计类相关课程;</van-col></van-row>
				<van-row><van-col span="24" style="font-size: 20px; text-align: left;margin:10px 10px;">2、认真备课，不断更新创新课程;</van-col></van-row>
				<van-row><van-col span="24" style="font-size: 20px; text-align: left;margin:10px 10px;">3、协助集团教研编写新的教学内容。</van-col></van-row>

				<van-row><van-col span="8" style="font-size: 20px;color: #10A01E;text-align: left;margin-left: 15px;">任职资格</van-col></van-row>
				<van-row><van-col span="24" style="font-size: 20px; text-align: left;margin:10px 10px;">1、年龄50岁以下，大专以上学历，财会类专业毕业优先;</van-col></van-row>
				<van-row>
					<van-col span="24" style="font-size: 20px; text-align: left;margin:10px 10px;">2、有亲和力，热爱教学工作，有良好的职业道德和个人诚信素质;</van-col>
				</van-row>
				<van-row>
					<van-col span="24" style="font-size: 20px; text-align: left;margin:10px 10px;">3、5年以上企业会计实践经验，要求会计岗位全面，熟练掌握会计知识;</van-col>
				</van-row>
				<van-row><van-col span="24" style="font-size: 20px; text-align: left;margin:10px 10px;">4、有一般纳税人企业做账经验，胜任教学工作，责任心强;</van-col></van-row>
				<van-row><van-col span="24" style="font-size: 20px; text-align: left;margin:10px 10px;">5、电脑使用熟练，掌握用友、新中大等财务软件的应用;</van-col></van-row>
				<van-row>
					<van-col span="24" style="font-size: 20px; text-align: left;margin:10px 10px;">6、有《会计证》、《会计初级职称》以上及相关课程讲课经验者优先录用</van-col>
				</van-row>
				<div style="background: white;">
					<van-row style="margin-top: 10px;padding: 0;">
						<van-col span="24" style=""></van-col>
						<img src="@/assets/page/b5.jpg" alt="" />
					</van-row>
					<van-row style="margin-top: 10px;">
						<van-col span="24" style="font-size: 20px; text-align: left;background: white;"><span style="margin-left:10px ;">联系人：张女士</span></van-col>
					</van-row>
					<van-row style="margin-top: 10px;">
						<van-col span="24" style="font-size: 20px; text-align: left;background: white;"><span style="margin-left:10px ; ">电话：58208426</span></van-col>
					</van-row>
					<van-row style="margin-top: 10px;">
						<van-col span="24" style="font-size: 20px; text-align: left;background: white;"><span style="margin-left:10px ; ">邮箱：chunxue1998@163.com</span></van-col>
					</van-row>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'page2',
	data() {
		return {};
	}
};
</script>

<style scoped="scoped">
img {
	width: 100%;
	height: 100%;
}
.van-row {
	padding-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/page/recruit.vue